<div class="notification__image-wrapper">
  <pp-icon class="notification__image" [ppSrc]="EIconPath.NOTIFICATION_ICON_ASSIGNEES" ppColor="primary-950"></pp-icon>
</div>

<span class="notification__blue-text">{{ 'you' | ppTranslate }}</span> {{ 'were' | ppTranslate }}
<span class="notification__bold">{{ 'assigned_lowercase' | ppTranslate }}</span>
{{ 'to_a_new_point' | ppTranslate }}
